import { useQuery } from "@tanstack/react-query";
import React from "react";
import Layout from "../../layout/Layout";
import Card from "../../components/Card/Card";
//icons
import { AiOutlinePlus } from "react-icons/ai";
//Components
import SurverItems from "../../components/SurveyItems/SurverItems";
//Screen
import Loader from "../../components/Loader/Loader";
import Error from "../Error/Error";
//APIs
import { getSurveys } from "../../services/ApiServices";
import { Helmet } from "react-helmet";

export default function Home() {
  const { isLoading, error, data, refetch } = useQuery(["testapi"], getSurveys);

  if (isLoading) return <Loader />;

  if (error)
    return (
      <Error
        error={error.message}
        code={error.request.status}
        text={"Giriş Ekranına Geri Dön "}
        historylink={"/"}
      />
    );

  return (
    <Layout>
      <div className="w-full h-full justify-center flex items-center flex-col ">
        <div className="application">
          <Helmet>
            <meta charSet="utf-8" />
            <title>Anketler | Anket Oluştur, Paylaş, Analiz Et</title>
          </Helmet>
        </div>

        <div className="flex flex-col w-full border-opacity-50 ">
          <div className="flex md:flex-row items-center justify-center  card  rounded-box place-items-center bg-gray-100  py-8 border-b-2">
            <Card
              icons={<AiOutlinePlus size={60} />}
              title={"Anket Oluştur"}
              description={
                "İçerisinde 4 farklı soru çeşidinin bulunduğu birden fazla soru ekleyebileceğiniz sayfayı açar"
              }
            />
          </div>

          <div className="md:grid xl:grid-cols-4  lg:grid-cols-3  gap-4 md:grid-cols-2 flex flex-col py-10 px-4 card rounded-box place-items-center ">
            {data.data.map((element, index) => {
              return (
                <SurverItems
                  key={index}
                  title={element.title}
                  id={element.id}
                  description={element.description}
                  refetch={() => refetch()}
                />
              );
            })}
          </div>
        </div>
      </div>
    </Layout>
  );
}
